import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBlankPageLandscape: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBlankPageLandscape"><Path fillRule="evenodd" clipRule="evenodd" d="M22 4H2V12.1429C2 14.8857 3.29141 17.4686 5.48571 19.1143C6.25228 19.6892 7.18465 20 8.14286 20H22V4ZM8.5 18H20V6H4.00112C4.03797 8.33553 4.98174 10.5675 6.63604 12.2218L8.2868 13.8726L7.83205 14.5547C7.49068 15.0668 7.27427 16.05 7.42228 16.8887C7.49331 17.2912 7.6335 17.5716 7.7933 17.7388C7.93052 17.8824 8.13321 18 8.5 18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBlankPageLandscape;
